import { Link } from "react-router-dom";

import "./faq.css";

const sectionData = [
  {
    title: "Schnellstart",
    items: [
      {
        question: "Wie erstelle ich eine MapArt?",
        answer:
          "Bild hochladen, Map-Groesse waehlen, Minecraft-Version einstellen, passende Bloecke aktivieren und die Vorschau pruefen. Danach kannst du die Schematic-ZIP herunterladen oder im Auftragssystem direkt an eine Kartenfirma senden.",
      },
      {
        question: "Was bedeutet Map-Groesse?",
        answer:
          "Eine Minecraft-Karte ist 128 x 128 Pixel gross. Eine Groesse von 2 x 3 bedeutet also sechs Kartenteile. Diese Anzahl wird auch fuer Auftraege und Preise verwendet.",
      },
      {
        question: "Warum sieht mein Bild anders aus als vorher?",
        answer:
          "Browser koennen Bilder minimal unterschiedlich skalieren. Fuer reproduzierbare Ergebnisse solltest du die erzeugte Vorschau und die exportierten Dateien zusammen mit deinem Auftrag speichern.",
      },
    ],
  },
  {
    title: "Vorschau, Raster und Farben",
    items: [
      {
        question: "Was machen Kartenraster, Detailraster und Chunkraster?",
        answer:
          "Das Kartenraster zeigt die einzelnen 128x128-Kartenteile. Detail- und Chunkraster helfen beim Bauen, Kontrollieren und Aufteilen grosser Motive.",
      },
      {
        question: "Was ist der Unterschied zwischen 2D und 3D?",
        answer:
          "2D ist flach und meist einfacher zu bauen. 3D nutzt Hoehenunterschiede fuer hellere und dunklere Kartentoene und kann deutlich mehr Tiefe erzeugen, ist aber aufwendiger.",
      },
      {
        question: "Was bedeutet 2D Teppich oder All Blocks?",
        answer:
          "2D Teppich nutzt Teppiche als flache Bauweise. All Blocks erlaubt deutlich mehr Blocktypen und kann bessere Farben liefern, ist aber beim Material und Bauaufwand komplexer.",
      },
    ],
  },
  {
    title: "Export und Dateien",
    items: [
      {
        question: "Was ist die Schematic-ZIP?",
        answer:
          "Die ZIP enthaelt die erzeugten Schematic-Dateien fuer den Auftrag. Bei mehreren Kartenteilen werden die Dateien passend zur Ticketnummer benannt, damit sie schneller wiedergefunden werden.",
      },
      {
        question: "Warum wird auch das Bild gespeichert?",
        answer:
          "Das Original-/Vorschaubild hilft der Kartenfirma und kann fuer OPSUCHT-Genehmigungen genutzt werden. Deshalb gibt es getrennte Download-Buttons fuer Bild und Schematic-ZIP.",
      },
      {
        question: "Kann ich die Exportfunktionen ohne Auftrag nutzen?",
        answer:
          "Ja. Das Auftragssystem ist einklappbar. Du kannst MapArtCraft weiterhin nur als Generator verwenden.",
      },
    ],
  },
  {
    title: "Account und Profil",
    items: [
      {
        question: "Wie registriere ich mich?",
        answer:
          "Die Registrierung nutzt deinen Ingame-Namen, ein Passwort und Cloudflare Turnstile. Die Sicherheitspruefung schuetzt gegen automatische Bot-Registrierungen.",
      },
      {
        question: "Was zeigt die Profilvorschau?",
        answer:
          "Die Profilvorschau zeigt, wie andere dein Profil sehen: Anzeigename, Ingame-Name, Profiltext, OPSUCHT-Status, Discord-Kopplung und ein genehmigtes Profilbild.",
      },
      {
        question: "Warum sehe ich mein Profilbild nicht sofort oeffentlich?",
        answer:
          "Profilbilder werden erst nach Admin-Genehmigung sichtbar. Das schuetzt die Plattform vor unpassenden Bildern und Jugendschutzproblemen.",
      },
      {
        question: "Wofuer ist 2FA?",
        answer:
          "2FA schuetzt wichtige Accounts zusaetzlich. Wenn du dein Handy verlierst, kann ein Administrator 2FA fuer deinen Account zuruecksetzen.",
      },
      {
        question: "Was passiert nach einem Admin-Passwortreset?",
        answer:
          "Der Administrator erzeugt ein temporaeres Passwort und gibt es dir direkt weiter. Damit loggst du dich ein und setzt danach unter Mein Profil > Passwort aendern sofort ein neues eigenes Passwort.",
      },
    ],
  },
  {
    title: "OPSUCHT-Verifizierung",
    items: [
      {
        question: "Wozu dient die OPSUCHT-Verifizierung?",
        answer:
          "Sie bestaetigt, dass du wirklich Besitzer deines angegebenen OPSUCHT-Spielaccounts bist. So kann sich niemand einfach mit fremdem Ingame-Namen ausgeben.",
      },
      {
        question: "Wie funktioniert die Verifizierung?",
        answer:
          "Du erzeugst im Profil einen Code, benennst auf OPSUCHT ein Blatt Papier exakt nach diesem Code und stellst es ins Auktionshaus. MapArtCraft prueft serverseitig ueber die oeffentliche OPSUCHT-Auktions-API, ob Papier, Code und Verkaeufer-UUID passen.",
      },
      {
        question: "Muss der Preis exakt stimmen?",
        answer:
          "Nein. Der angezeigte Preis ist nur eine Empfehlung. Wenn jemand bietet und der aktuelle Preis steigt, bleibt die Verifizierung trotzdem moeglich.",
      },
      {
        question: "Warum wird eine Minecraft-UUID gespeichert?",
        answer:
          "Die UUID ist eine dauerhafte technische Identitaet und hilft spaeter bei Namensaenderungen. Sie ersetzt nicht die OPSUCHT-Verifizierung.",
      },
    ],
  },
  {
    title: "Feedback-System",
    items: [
      {
        question: "Wofuer ist der Feedback-Button?",
        answer:
          "Mit dem Feedback-Button gibst du der Community eine direkte Stimme. Du kannst Fehler melden, Ideen einreichen, Kritik aeussern, Lob senden oder allgemeines Feedback geben. Jede Meldung landet zentral im Backend und kann vom Team strukturiert bearbeitet werden.",
      },
      {
        question: "Wer darf Feedback einreichen?",
        answer:
          "Feedback kann nur von angemeldeten und erfolgreich verifizierten OPSUCHT-Spielern eingereicht werden. Diese Pruefung passiert serverseitig, damit niemand die Sperre nur im Browser umgehen kann.",
      },
      {
        question: "Was wird beim Feedback gespeichert?",
        answer:
          "Gespeichert werden deine Feedback-ID, dein Ingame-Name, OPSUCHT-Verifizierungsstatus, Kategorie, Titel, Beschreibung, optionale Kontextfelder und bei Bedarf ein Screenshot. Passwoerter, Tokens, Cookies oder andere sensible Inhalte werden nicht erfasst.",
      },
      {
        question: "Wo sehe ich den Status meiner Meldung?",
        answer:
          "Im Auftragssystem gibt es den Tab Feedback. Dort siehst du deine eingereichten Meldungen, Status, letzte Aktualisierung und eine oeffentliche Antwort des Teams, falls eine hinterlegt wurde.",
      },
      {
        question: "Was passiert mit Screenshots?",
        answer:
          "Screenshots sind optional und werden serverseitig auf PNG, JPG oder WEBP geprueft. Sie sind nicht als erratbare oeffentliche Datei gedacht, sondern fuer berechtigte Teammitglieder im Admin-Dashboard.",
      },
    ],
  },
  {
    title: "Versteckte Funktionen",
    items: [
      {
        question: "Gibt es Easter Eggs?",
        answer:
          "Ja. Manche Dinge reagieren nicht auf sichtbare Buttons, sondern auf aufmerksames Ausprobieren. Die Webseite merkt sich dabei keine wilden Eingaben, sondern wartet nur auf bestimmte kleine Signale.",
      },
      {
        question: "Wie finde ich versteckte Themes?",
        answer:
          "Achte auf Namen, Stimmungen, Farben und Begriffe, die rund um Generator, Serverwelt, Assistenten und Kartenfirmen immer wieder auftauchen. Einige Hinweise liegen eher im Design als im Text.",
      },
      {
        question: "Kann ich ein gefundenes Theme behalten?",
        answer:
          "Wenn du ein verstecktes Design gefunden hast, lohnt sich ein zweiter Gedanke daran, wie man etwas festhaelt. Gespeicherte Designs gehoeren zu deinem Account und koennen beim Login wieder aktiv werden.",
      },
      {
        question: "Gibt es mehr als Tastatur-Geheimnisse?",
        answer:
          "Nicht jedes Easter Egg beginnt mit Schreiben. Manchmal lohnt es sich, ruhige Ecken, kleine Signale und ungewoehnliche Details nicht sofort zu ignorieren.",
      },
      {
        question: "Warum stehen hier keine Loesungen?",
        answer:
          "Weil ein Easter Egg nur dann Spass macht, wenn es nicht wie eine Checkliste wirkt. Wenn du eins findest, bekommst du in der Regel direkt ein kleines visuelles Feedback oder einen Erfolg.",
      },
    ],
  },
  {
    title: "Auftragssystem fuer Kunden",
    items: [
      {
        question: "Wie erstelle ich einen Auftrag?",
        answer:
          "Stelle unten im Generator deine MapArt ein. Das Auftragssystem uebernimmt Map-Groesse, Kategorie, Vorschau und Dateien. Danach suchst du eine passende Kartenfirma aus und sendest den Auftrag ab.",
      },
      {
        question: "Wie werden passende Firmen gefunden?",
        answer:
          "Firmen hinterlegen Kategorien und Preise. Wenn dein Budget passt, erscheinen sie als Auswahl. Danach kann die Firma den Auftrag annehmen oder ablehnen.",
      },
      {
        question: "Kann ich einen Auftrag stornieren?",
        answer:
          "Ja, solange er noch nicht abholbereit, abgeschlossen, abgelehnt oder bereits storniert ist. Beim Storno wird auch das Discord-Ticket geschlossen.",
      },
      {
        question: "Wo sehe ich den Status?",
        answer:
          "Unter 'Meine Auftraege' siehst du Status, Bearbeiter, Fortschritt, Zahlung, Vorschau und Download-Dateien.",
      },
    ],
  },
  {
    title: "Firmen-Dashboard",
    items: [
      {
        question: "Was kann eine Kartenfirma verwalten?",
        answer:
          "Profil, CityBuild, Swap, Discord-Link, Webseite, Auftragstypen, Preise, Mitglieder, Mitarbeiter-Anfragen, Discord-Ziel und Auftraege.",
      },
      {
        question: "Wofuer ist das Firmenkuerzel?",
        answer:
          "Das Kuerzel wird in Ticketnummern verwendet, zum Beispiel MAC-PHCO-123456. So erkennt man schneller, zu welcher Kartenfirma ein Auftrag gehoert.",
      },
      {
        question: "Was bedeuten Mitglieder und Manager?",
        answer:
          "Mitglieder koennen Auftraege bearbeiten. Manager koennen zusaetzlich Profil, Preise und Einstellungen der Kartenfirma pflegen.",
      },
      {
        question: "Was passiert mit abgeschlossenen Auftraegen?",
        answer:
          "Bezahlte und abgeschlossene Auftraege landen im Auftragsarchiv. Das Archiv ist einklappbar, damit lange Historien nicht die ganze Seite fuellen.",
      },
      {
        question: "Wie wird Fortschritt gepflegt?",
        answer:
          "Die Firma kann fertige Kartenteile setzen und Status wie Angenommen, In Arbeit, Abholbereit oder Abgeschlossen waehlen. Kunden sehen diese Infos in ihrer Auftragsuebersicht.",
      },
    ],
  },
  {
    title: "Discord und Shiori",
    items: [
      {
        question: "Was macht Shiori?",
        answer:
          "Shiori ist der Discord-Bot fuer MapArtCraft. Er kann Accounts verknuepfen, Auftrags-Tickets erstellen und Statusinformationen in Discord spiegeln.",
      },
      {
        question: "Wie kopple ich Discord?",
        answer:
          "Im Profil erzeugst du einen Kopplungscode und verwendest im Discord-Bot den Slash-Befehl /link mit diesem Code.",
      },
      {
        question: "Wie lade ich Shiori auf meinen Discord ein?",
        answer:
          "Owner oder Manager oeffnen im Firmen-Dashboard den Tab Discord und nutzen dort 'Bot einladen'. Der Link nutzt die Scopes bot und applications.commands. Der Discord-Server muss erlauben, dass du Bots hinzufuegst.",
      },
      {
        question: "Welche Discord-Rechte braucht Shiori?",
        answer:
          "Shiori braucht View Channels, Send Messages, Use Slash Commands, Embed Links und Manage Channels. Read Message History ist zusaetzlich hilfreich. Ohne Manage Channels kann Shiori keine Ticket-Textkanaele in einer Kategorie erstellen.",
      },
      {
        question: "Was muss nach dem Einladen eingestellt werden?",
        answer:
          "Danach im Firmen-Dashboard Discord-Ziele aktualisieren, den Discord-Server waehlen, eine Kategorie oder ein Forum als Ziel setzen und automatische Discord-Tickets aktivieren. Erst dann werden neue Auftraege automatisch nach Discord gespiegelt.",
      },
      {
        question: "Was passiert in Discord-Tickets?",
        answer:
          "Neue Auftraege koennen automatisch als Channel oder Forum-Post erstellt werden. Dort gibt es Buttons fuer Annehmen, In Arbeit, Abholbereit, Abgeschlossen, Ablehnen und Als bezahlt markieren.",
      },
      {
        question: "Wann wird ein Discord-Ticket geschlossen?",
        answer:
          "Wenn ein Auftrag abgeschlossen und bezahlt ist, wird das Ticket geschlossen. Das funktioniert sowohl von der Webseite als auch aus Discord. Kundenstorno schliesst das Ticket ebenfalls.",
      },
    ],
  },
  {
    title: "Preise, Material und OPSUCHT-Markt",
    items: [
      {
        question: "Was macht der Kundenpreis-Rechner?",
        answer:
          "Er berechnet Preise pro Kartenteil, Gesamtpreis und Rabatte. Die Kartenteile werden aus der Map-Groesse uebernommen.",
      },
      {
        question: "Was macht der Materialkosten-Rechner?",
        answer:
          "Er listet benoetigte Bloecke und kann Preise aus manuellen Werten, Cache oder OPSUCHT-API anzeigen. Fehlende Preise bleiben manuell pflegbar.",
      },
      {
        question: "Warum kosten manche Materialien 0?",
        answer:
          "Wiederverwendbare Dinge wie Wassereimer koennen bewusst mit 0 gerechnet werden. Spaeter koennen weitere Crafting-Umrechnungen gepflegt werden.",
      },
    ],
  },
  {
    title: "Administration und Sicherheit",
    items: [
      {
        question: "Was kann der Administrator?",
        answer:
          "User sperren, Sessions zuruecksetzen, temporaere Passwoerter erzeugen, 2FA deaktivieren, User loeschen, Profilbilder genehmigen, OPSUCHT-Verifizierung aufheben, Firmen pflegen und Shiori steuern.",
      },
      {
        question: "Warum gibt es Turnstile und Profilbild-Genehmigung?",
        answer:
          "Cloudflare Turnstile verhindert Massenregistrierungen. Profilbild-Genehmigung verhindert unpassende Inhalte und schuetzt juengere Nutzer.",
      },
      {
        question: "Wie bleibt diese FAQ aktuell?",
        answer:
          "Neue Nutzerfunktionen sollen ab jetzt in dieser FAQ ergaenzt werden. Wenn eine Funktion fuer Kunden, Firmen, Discord oder Admins sichtbar ist, gehoert sie hier hinein.",
      },
    ],
  },
];

function getSectionId(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function FAQ(props) {
  const countryPrefix = ![undefined, "en"].includes(props.match.params.countryCode) ? props.match.params.countryCode : "";

  return (
    <main className="FAQ">
      <Link className="faqBackLink" to={`/${countryPrefix}`}>
        Zurueck zu MapArtCraft
      </Link>

      <header className="faqHero">
        <h1>Deutschsprachiges FAQ</h1>
        <p>
          Diese Hilfe erklaert die wichtigsten Funktionen von Flammengott's MapArt Craft: Generator, Auftragssystem,
          Profile, OPSUCHT-Verifizierung, Firmen-Dashboard, Discord-Bot und Preise.
        </p>
        <small>Stand: wird bei neuen Nutzerfunktionen direkt mit gepflegt.</small>
      </header>

      <nav className="faqIndex" aria-label="FAQ Bereiche">
        {sectionData.map((section) => (
          <a href={`#${getSectionId(section.title)}`} key={section.title}>
            {section.title}
          </a>
        ))}
      </nav>

      {sectionData.map((section) => (
        <section className="faqSection" id={getSectionId(section.title)} key={section.title}>
          <h2>{section.title}</h2>
          <div className="faqQuestionGrid">
            {section.items.map((item) => (
              <article className="faqQuestion" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </article>
            ))}
          </div>
        </section>
      ))}
    </main>
  );
}

export default FAQ;
